var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 36.6667C10.1286 36.6667 2.66666 29.2048 2.66666 20C2.66666 10.7953 10.1286 3.33337 19.3333 3.33337C28.5381 3.33337 36 10.7953 36 20C36 29.2048 28.5381 36.6667 19.3333 36.6667Z",
    fill: "#060A33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8976 21.7729C12.0071 21.5265 12.1988 21.3211 12.459 21.2115C12.5822 21.1568 12.7191 21.1294 12.8561 21.1294H26.9731C27.5345 21.1294 28 21.5949 28 22.1563C28 22.7177 27.5345 23.1833 26.9731 23.1833H15.3344L17.7443 25.5932C18.1414 25.9903 18.1414 26.6475 17.7443 27.0446C17.5389 27.25 17.2788 27.3458 17.0186 27.3458C16.7585 27.3458 16.4983 27.25 16.2929 27.0446L12.1304 22.882C12.0345 22.7862 11.9661 22.6767 11.9113 22.5534C11.8017 22.307 11.8017 22.0194 11.8976 21.7729Z",
    fill: "#22E0BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8561 16.1591H24.4947L22.0848 13.7493C21.6877 13.3522 21.6877 12.6949 22.0848 12.2978C22.4819 11.9007 23.1391 11.9007 23.5362 12.2978L27.6988 16.4604C27.7946 16.5562 27.8631 16.6658 27.9178 16.789C28.0274 17.0355 28.0274 17.323 27.9178 17.5694C27.8083 17.8159 27.6166 18.0213 27.3564 18.1308C27.2332 18.1856 27.0963 18.213 26.9594 18.213H12.8424C12.281 18.213 11.8154 17.7475 11.8154 17.1861C11.8154 16.6247 12.281 16.1591 12.8561 16.1591Z",
    fill: "#22E0BB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.b18d96f40084f22719cf78042641f352.svg";
export { ForwardRef as ReactComponent };